import Codes from 'components/Icons/typedImages/codes.svg';
import SmogReadiness from 'components/Icons/typedImages/smog.svg';
import UnderhoodOveral from 'components/Icons/typedImages/underhoodOverall.svg';
import Oil from 'components/Icons/typedImages/oil.svg';
import Coolant from 'components/Icons/typedImages/coolant.svg';

import UnderhoodOveralBright from 'components/Icons/typedImages/underhoodOverall_bright.svg';
import OilBright from 'components/Icons/typedImages/oil_bright.svg';
import CoolantBright from 'components/Icons/typedImages/coolant_bright.svg';

import {
  Vin,
  LicensePlate,
  DriverRearTire,
  DriverRearWheel,
  DriverFrontTire,
  DriverFrontWheel,
  PassengerFrontTire,
  PassengerRearTire,
  PassengerRearWheel,
  PassengerFrontWheel
} from '../tires/icons';

export const BinIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <rect width="24" height="24" rx="8" fill="white" />
    <path
      d="M8.66406 17C8.2974 17 7.98351 16.8694 7.7224 16.6083C7.46128 16.3472 7.33073 16.0333 7.33073 15.6667V7C7.14184 7 6.98351 6.93611 6.85573 6.80833C6.72795 6.68056 6.66406 6.52222 6.66406 6.33333C6.66406 6.14444 6.72795 5.98611 6.85573 5.85833C6.98351 5.73056 7.14184 5.66667 7.33073 5.66667H9.9974C9.9974 5.47778 10.0613 5.31944 10.1891 5.19167C10.3168 5.06389 10.4752 5 10.6641 5H13.3307C13.5196 5 13.678 5.06389 13.8057 5.19167C13.9335 5.31944 13.9974 5.47778 13.9974 5.66667H16.6641C16.853 5.66667 17.0113 5.73056 17.1391 5.85833C17.2668 5.98611 17.3307 6.14444 17.3307 6.33333C17.3307 6.52222 17.2668 6.68056 17.1391 6.80833C17.0113 6.93611 16.853 7 16.6641 7V15.6667C16.6641 16.0333 16.5335 16.3472 16.2724 16.6083C16.0113 16.8694 15.6974 17 15.3307 17H8.66406ZM15.3307 7H8.66406V15.6667H15.3307V7ZM10.6641 14.3333C10.853 14.3333 11.0113 14.2694 11.1391 14.1417C11.2668 14.0139 11.3307 13.8556 11.3307 13.6667V9C11.3307 8.81111 11.2668 8.65278 11.1391 8.525C11.0113 8.39722 10.853 8.33333 10.6641 8.33333C10.4752 8.33333 10.3168 8.39722 10.1891 8.525C10.0613 8.65278 9.9974 8.81111 9.9974 9V13.6667C9.9974 13.8556 10.0613 14.0139 10.1891 14.1417C10.3168 14.2694 10.4752 14.3333 10.6641 14.3333ZM13.3307 14.3333C13.5196 14.3333 13.678 14.2694 13.8057 14.1417C13.9335 14.0139 13.9974 13.8556 13.9974 13.6667V9C13.9974 8.81111 13.9335 8.65278 13.8057 8.525C13.678 8.39722 13.5196 8.33333 13.3307 8.33333C13.1418 8.33333 12.9835 8.39722 12.8557 8.525C12.728 8.65278 12.6641 8.81111 12.6641 9V13.6667C12.6641 13.8556 12.728 14.0139 12.8557 14.1417C12.9835 14.2694 13.1418 14.3333 13.3307 14.3333Z"
      fill="#999999"
    />
  </svg>
);

export const OdometerFirstIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
    <path
      d="M27.77 17.2148C27.77 17.2148 24.8092 25.5583 23.403 27.0149C22.7241 27.6994 21.803 28.0891 20.839 28.0995C19.8751 28.1099 18.9457 27.7402 18.2523 27.0705C17.5588 26.4008 17.157 25.4849 17.1339 24.5212C17.1107 23.5574 17.468 22.6233 18.1285 21.921C19.5346 20.4635 27.77 17.2148 27.77 17.2148Z"
      stroke="#999999"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M35.6125 35.6125C37.4024 33.8266 38.8219 31.7047 39.7893 29.3687C40.7568 27.0326 41.2532 24.5285 41.25 22C41.25 11.3685 32.6315 2.75 22 2.75C11.3685 2.75 2.75 11.3685 2.75 22C2.75 27.3158 4.90417 32.1282 8.3875 35.6125M22 3.66667V7.33333M35.6079 10.2135L32.7589 12.5208M38.9785 24.9636L35.4063 24.1386M5.02058 24.9636L8.59375 24.1386M8.39208 10.2135L11.2411 12.5208"
      stroke="#999999"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path d="M22.6719 34.4453V43H21.1191V36.2559L19.0625 36.9355V35.6816L22.4961 34.4453H22.6719Z" fill="#999999" />
  </svg>
);

export const OdometerSecondIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="44" height="44" viewBox="0 0 44 44" fill="none">
    <path
      d="M24.9473 41.7812V43H19.1699V41.957L21.9414 38.9629C22.2305 38.6348 22.459 38.3496 22.627 38.1074C22.7949 37.8652 22.9141 37.6465 22.9844 37.4512C23.0586 37.252 23.0957 37.0625 23.0957 36.8828C23.0957 36.6211 23.0488 36.3926 22.9551 36.1973C22.8613 35.998 22.7246 35.8438 22.5449 35.7344C22.3691 35.625 22.1523 35.5703 21.8945 35.5703C21.6094 35.5703 21.3652 35.6367 21.1621 35.7695C20.9629 35.8984 20.8105 36.0781 20.7051 36.3086C20.6035 36.5391 20.5527 36.8027 20.5527 37.0996H19C19 36.5957 19.1172 36.1367 19.3516 35.7227C19.5859 35.3047 19.9219 34.9707 20.3594 34.7207C20.7969 34.4707 21.3164 34.3457 21.918 34.3457C22.5039 34.3457 23 34.4434 23.4062 34.6387C23.8125 34.8301 24.1211 35.1035 24.332 35.459C24.543 35.8145 24.6484 36.2383 24.6484 36.7305C24.6484 37.0039 24.6035 37.2734 24.5137 37.5391C24.4238 37.8047 24.2969 38.0684 24.1328 38.3301C23.9727 38.5879 23.7812 38.8496 23.5586 39.1152C23.3359 39.3809 23.0879 39.6523 22.8145 39.9297L21.1504 41.7812H24.9473Z"
      fill="#999999"
    />
    <path
      d="M27.77 17.2148C27.77 17.2148 24.8092 25.5583 23.403 27.0149C22.7241 27.6994 21.803 28.0891 20.839 28.0995C19.8751 28.1099 18.9457 27.7402 18.2523 27.0705C17.5588 26.4008 17.157 25.4849 17.1339 24.5212C17.1107 23.5574 17.468 22.6233 18.1285 21.921C19.5346 20.4635 27.77 17.2148 27.77 17.2148Z"
      stroke="#999999"
      stroke-width="2"
      stroke-linejoin="round"
    />
    <path
      d="M35.6125 35.6125C37.4024 33.8266 38.8219 31.7047 39.7893 29.3687C40.7568 27.0326 41.2532 24.5285 41.25 22C41.25 11.3685 32.6315 2.75 22 2.75C11.3685 2.75 2.75 11.3685 2.75 22C2.75 27.3158 4.90417 32.1282 8.3875 35.6125M22 3.66667V7.33333M35.6079 10.2135L32.7589 12.5208M38.9785 24.9636L35.4063 24.1386M5.02058 24.9636L8.59375 24.1386M8.39208 10.2135L11.2411 12.5208"
      stroke="#999999"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

export const typeToIcon: Record<string, React.ReactNode> = {
  'interior.odometer_1': <OdometerFirstIcon />,
  'drive_cycles.odometer_2': <OdometerSecondIcon />,
  'obd.codes': <Codes />,
  'obd.smog_readiness': <SmogReadiness />,
  'under_hood.overall': <UnderhoodOveral />,
  'under_hood.oil': <Oil />,
  'under_hood.coolant': <Coolant />,
  'tires.driver_front_tire': <DriverFrontTire />,
  'tires.driver_front_wheel': <DriverFrontWheel />,
  'tires.driver_rear_tire': <DriverRearTire />,
  'tires.driver_rear_wheel': <DriverRearWheel />,
  'tires.passenger_front_tire': <PassengerFrontTire />,
  'tires.passenger_front_wheel': <PassengerFrontWheel />,
  'tires.passenger_rear_tire': <PassengerRearTire />,
  'tires.passenger_rear_wheel': <PassengerRearWheel />,
  'tires.vin_plate': <Vin />,
  'tires.license_plate_registration': <LicensePlate />
};

export const cameraTypeToIcon: Record<string, React.ReactNode> = {
  'interior.odometer_1': <OdometerFirstIcon />,
  'drive_cycles.odometer_2': <OdometerSecondIcon />,
  'obd.codes': <Codes />,
  'obd.smog_readiness': <SmogReadiness />,
  'under_hood.overall': <UnderhoodOveralBright />,
  'under_hood.oil': <OilBright />,
  'under_hood.coolant': <CoolantBright />,
  'tires.driver_front_tire': <DriverFrontTire />,
  'tires.driver_front_wheel': <DriverFrontWheel />,
  'tires.driver_rear_tire': <DriverRearTire />,
  'tires.driver_rear_wheel': <DriverRearWheel />,
  'tires.passenger_front_tire': <PassengerFrontTire />,
  'tires.passenger_front_wheel': <PassengerFrontWheel />,
  'tires.passenger_rear_tire': <PassengerRearTire />,
  'tires.passenger_rear_wheel': <PassengerRearWheel />,
  'tires.vin_plate': <Vin />,
  'tires.license_plate_registration': <LicensePlate />
};

export const typeToLabel: Record<string, string> = {
  'tires.driver_front_tire': 'Driver Front Tire',
  'tires.driver_front_wheel': 'Driver Front Wheel',
  'tires.driver_rear_tire': 'Driver Rear Tire',
  'tires.driver_rear_wheel': 'Driver Rear Wheel',
  'tires.passenger_front_tire': 'Passenger Front Tire',
  'tires.passenger_front_wheel': 'Passenger Front Wheel',
  'tires.passenger_rear_tire': 'Passenger Rear Tire',
  'tires.passenger_rear_wheel': 'Passenger Rear Wheel',
  'tires.vin_plate': 'VIN Plate',
  'tires.license_plate_registration': 'License Plate',
  'interior.odometer_1': 'Dash first picture',
  'drive_cycles.odometer_2': 'Dash second picture',
  'obd.codes': 'Codes',
  'obd.smog_readiness': 'Smog Readiness',
  'under_hood.overall': 'Under hood overall',
  'under_hood.oil': 'Oil',
  'under_hood.coolant': 'Coolant'
};
